import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';
import FormDataContext from 'integrations/contexts/FormDataContext';

import { Input } from 'components/bootstrap';

import { AdvancedOptionsContext } from './context/AdvancedOptions';

type FormAdvancedOptionsProps = {
  onChange: (...args: any[]) => void;
};

const FormAdvancedOptions = ({ onChange }: FormAdvancedOptionsProps) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);

  const { gcpThrottleEnabled, pageSize } = formData;

  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox id="gcpThrottleEnabled" defaultChecked={gcpThrottleEnabled?.value} onChange={onChange} />
      <Input
        id="pageSize"
        type="number"
        value={pageSize.value || pageSize.defaultValue}
        min="1000"
        onChange={onChange}
        required
        help="Determines the maximum number logs to return per page of query results."
        label="Page size"
      />
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
